import { Navigate } from "react-router-dom";
import { hasRole } from "./roleManager";

export default function ProtectedRoute({
  allowedRoles,
  children,
}) {
  if (!hasRole(allowedRoles)) {
    return <Navigate to="/" replace />;
  }

  return children;
}